export const I18n = {
	'en': {
		arch: 'Architecture:',
		attributes: 'APK attributes'

	},
	'ru': {
		arch: 'Архитектура:',
		attributes: 'Атрибуты АПК'
	},
	'sk': {
		arch: 'Architektúra:',
		attributes: 'Atribúty APK'
	}
};



// WEBPACK FOOTER //
// ./src/I18n/components/apk/index.js